import React from "react";
import { Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

// Interne paden die we in lopende juridische/info-tekst automatisch klikbaar maken.
const INTERNAL_PATHS = ["/privacy", "/cookies", "/sub-verwerkers", "/voorwaarden", "/algemene-voorwaarden", "/privacystandaard", "/hoe-het-werkt", "/terugbetaling", "/veelgestelde-vragen"];
const PATH_RE = new RegExp(`(${INTERNAL_PATHS.map((p) => p.replace(/\//g, "\\/")).join("|")})`, "g");

/** Zet interne paden (/cookies, /privacy, ...) in een tekst om naar router-links. */
export function linkifyPaths(text: string): React.ReactNode {
  const parts = text.split(PATH_RE);
  if (parts.length === 1) return text;
  return parts.map((part, i) =>
    INTERNAL_PATHS.includes(part) ? (
      <MuiLink key={i} component={RouterLink} to={part} sx={{ color: "primary.main", fontWeight: 500 }}>{part}</MuiLink>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
}
